module.exports = __webpack_public_path__ + "393ce09d2e8798cbd7bff7e1978efa71.png";